import {
  TOGGLE_DASHBOARD_WIDGET,
  RESET_DASHBOARD_WIDGETS,
} from '../constants/dashboardWidgetVisibility'

const STORAGE_KEY = 'hiddenDashboardWidgets'

const loadInitialHiddenKeys = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    return stored ? JSON.parse(stored) : []
  } catch (err) {
    return []
  }
}

const initialState = {
  hiddenKeys: loadInitialHiddenKeys(),
}

export default function dashboardWidgetVisibility(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_DASHBOARD_WIDGET: {
      const isHidden = state.hiddenKeys.includes(action.key)
      return {
        ...state,
        hiddenKeys: isHidden
          ? state.hiddenKeys.filter((key) => key !== action.key)
          : [...state.hiddenKeys, action.key],
      }
    }

    case RESET_DASHBOARD_WIDGETS:
      return { ...state, hiddenKeys: [] }

    default:
      return state
  }
}
